import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-341b2bba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"justify-content":"flex-end","align-items":"center","position":"relative"},
  class: "Section__Wrapper-sc-8gk3sk-0 gA-dVqj Map__WrapperSection-vjdwv-1 jFdWTu",
  height: "100vh",
  width: "100vw",
  overflow: "hidden"
}
const _hoisted_2 = { class: "Map__Collapse-vjdwv-3 jVYqpD" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<g class=\"rsm-geographies\" data-v-341b2bba></g><g transform=\"translate(693.2095553280174, 221.04537048975834)\" class=\"rsm-marker Map__MapMarker-vjdwv-0 eBaxQw\" data-v-341b2bba><g fill=\"transparent\" stroke=\"#475BBB\" stroke-width=\"5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(-12, -24)\" data-v-341b2bba><circle cx=\"12\" cy=\"10\" r=\"8\" data-v-341b2bba></circle></g></g><g transform=\"translate(668.933357491276, 211.47199531046562)\" class=\"rsm-marker Map__MapMarker-vjdwv-0 eBaxQw\" data-v-341b2bba><g fill=\"transparent\" stroke=\"#000000\" stroke-width=\"5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(-12, -24)\" data-v-341b2bba><circle cx=\"12\" cy=\"10\" r=\"8\" data-v-341b2bba></circle></g></g><g transform=\"translate(665.8067127675529, 251.97902616699693)\" class=\"rsm-marker Map__MapMarker-vjdwv-0 eBaxQw\" data-v-341b2bba><g fill=\"transparent\" stroke=\"#000000\" stroke-width=\"5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(-12, -24)\" data-v-341b2bba><circle cx=\"12\" cy=\"10\" r=\"8\" data-v-341b2bba></circle></g></g><g transform=\"translate(107.0358239850475, 169.76889077960413)\" class=\"rsm-marker Map__MapMarker-vjdwv-0 eBaxQw\" data-v-341b2bba><g fill=\"transparent\" stroke=\"#000000\" stroke-width=\"5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(-12, -24)\" data-v-341b2bba><circle cx=\"12\" cy=\"10\" r=\"8\" data-v-341b2bba></circle></g></g>", 5)
const _hoisted_8 = [
  _hoisted_3
]
const _hoisted_9 = ["offset", "active", "calcappend"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "address" }
const _hoisted_14 = ["href"]

import { ref, reactive, onMounted, watch } from "vue";

import { MapItem } from '@/interface/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapItem',
  setup(__props) {

const isActiveIndex = ref<number>(2) //定位
const calcappend = ref<number>(0)
const mapWidth = ref<number>(170)
const isOpacity = ref<boolean>(false)

const MapList = ref<MapItem[]>([
    {
        src: require('@/assets/maps/hongKong.jpg'),
        title: 'Cosmo Headquarter',
        name: 'Hong Kong',
        address: 'Room A155, 16/F, Tower 5, The Gateway, Harbour City, Kowloon, Hong Kong',//'Unit 2201, Tower 6, The Gateway, Harbour City, Kowloon, Hong Kong',
        // url: 'https://goo.gl/maps/W5GV97aui5LVJwmo8', //使用的是分享地址 https://maps.app.goo.gl/D7fwNWwSyaWH5PCJ9
        // url: 'https://maps.app.goo.gl/CJ4Qck4CejLsYoZZ8',
        url: 'https://goo.gl/maps/NZS2CzgdKAansE4J7',
        urlText: 'Open in google maps',
        isOpen: false,
        isActive: false,
    },
    {
        src: require('@/assets/maps/thailand.jpg'),
        title: 'Cosmo Manufacturing',
        name: 'Cosmo Manufacturing Thailand',
        address: `700/1032 Moo 9 Tambol Map Pong Amphur Phan thong, Chonburi Thailand 20160`,
        url: 'https://goo.gl/maps/qZX8echfB8cTBcZg6',
        urlText: 'Open in google maps',
        isOpen: false,
        isActive: false,
    },
    /*  {
         src: require('@/assets/maps/sanFran.jpg'),
         title: 'Cosmo Design Lab',
         name: 'San Francisco',
         address: '3030 17th Street, San Francisco, CA 94110 USA',
         url: 'https://goo.gl/maps/hA75SL8tEbbHeV7H8',
         urlText: 'Open in google maps',
         isOpen: false,
         isActive: false,
     }, */
    /* {
        src: require('@/assets/maps/chinaM1.jpg'),
        title: 'Cosmo Manufacturing',
        name: 'Cosmo Manufacturing China',
        address: 'GBF1, North Square Road, Gaobu Town, Dongguan, Guangdong, PRC, 广东省东莞市高埗镇冼沙工业区广场北路, 523270',
        url: 'https://goo.gl/maps/GmdYCrKbKHLciFRF9',
        urlText: 'Open in google maps',
        isOpen: false,
        isActive: false, 
    }, */
    {
        src: require('@/assets/maps/china.jpg'),
        title: 'Cosmo Manufacturing',
        name: 'China - M1',
        address: `Zhongxin Central Road, Xian Sha Industrial Zone, Gaobu Town Dongguan, Guangdong Province`,
        url: 'https://goo.gl/maps/xauMtsgrP63Pab876',
        urlText: 'Open in google maps',
        isOpen: false,
        isActive: true,
    },
    {
        src: require('@/assets/maps/china.jpg'),
        title: 'Cosmo Manufacturing',
        name: 'China - M2',
        address: `GBF3B, Baiwang Technology Park, SanLian Village, Gaobu Town, Dongguan, Guangdong, PRC, 广东省东莞市高埗镇三联村佰旺科技园卡士莫3B厂, 523270`,
        url: 'https://goo.gl/maps/ZvhzQXRVAVovqZDGA',
        urlText: 'Open in google maps',
        isOpen: false,
        isActive: false,
    },
   
    {
        src: require('@/assets/maps/china.jpg'),
        title: 'Cosmo Lab',
        name: 'Cosmo Lab China',
        // address: `GBF1 - Lab, North Square Road, Gaobu Town, Dongguan, Guangdong, PRC, 广东省东莞市高埗镇冼沙工业区广场北路, 523270`,
        // url: 'https://goo.gl/maps/GmdYCrKbKHLciFRF9',
        address: `GBF3B, Baiwang Technology Park, SanLian Village, Gaobu Town, Dongguan, Guangdong, PRC, 广东省东莞市高埗镇三联村佰旺科技园卡士莫3B厂, 523270`,
        url: 'https://goo.gl/maps/ZvhzQXRVAVovqZDGA',
        urlText: 'Open in google maps',
        isOpen: false,
        isActive: false,
    },
    /*  {
         src: require('@/assets/maps/chinaL2.jpg'),
         title: 'Cosmo Lab',
         name: 'China - L2',
         address: `GBF3B - Lab, Baiwang Technology Park, SanLian Village, Gaobu Town, Dongguan, Guangdong, PRC, 广东省东莞市高埗镇三联村佰旺科技园卡士莫3B厂, 523270`,
         url: 'https://goo.gl/maps/ZvhzQXRVAVovqZDGA',
         urlText: 'Open in google maps',
         isOpen: false,
         isActive: false,
     }, */
])

const handleItem = (index: number) => {
    if (isActiveIndex.value != index) {
        isActiveIndex.value = index;
        MapList.value.forEach(res => {
            res.isActive = false;
            res.isOpen = false;
        })
        MapList.value[index].isActive = true;
        MapList.value[index].isOpen = false;
    } else {
        MapList.value[index].isOpen = !MapList.value[index].isOpen;
    }
    isOpacity.value = MapList.value[index].isOpen ? true : false

}

onMounted(() => {
    // document.querySelector('.map')?.addEventListener('resize', function (e) {
    //     console.log(e.target)
    // })
    // handleItem(isActiveIndex.value);
    window.onresize = function () {
        let w = document.querySelector('.map')?.clientWidth
        mapWidth.value = w ? w / 2 : 170
        if (window.innerWidth >= 699.5) {
            calcappend.value = 0.4
        } else {
            calcappend.value = 0.7
        }
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      style: _normalizeStyle([{"transition":"opacity 200ms","opacity":"1"}, { opacity: isOpacity.value ? 0.05 : 1 }]),
      class: "styles__XLargeH-sc-1d0iomf-2 Map__Header-vjdwv-4 gKnMJX"
    }, "Our locations", 4),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 800 600",
        class: "rsm-svg",
        style: _normalizeStyle([{"transition":"opacity 200ms ease 0s","transform":"none","opacity":"1"}, { opacity: isOpacity.value ? 0.05 : 1 }])
      }, _hoisted_8, 4))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        offset: mapWidth.value + isActiveIndex.value * mapWidth.value * 2,
        active: isActiveIndex.value,
        style: {"padding":"2vw 0"},
        calcappend: `- ${calcappend.value}%`,
        speed: "200",
        class: "HorizontalNav__Wrapper-sc-1th6xrl-0 dXelTk"
      }, [
        _createElementVNode("ul", {
          style: _normalizeStyle({ transform: `translateX(calc((50% - (${mapWidth.value + isActiveIndex.value * mapWidth.value * 2}px)) - ${calcappend.value}%))` })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(MapList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (handleItem(index))
            }, [
              _createElementVNode("div", {
                theme: "[object Object]",
                class: _normalizeClass(["Map__MapCard-vjdwv-2", { gJsnVc: !item.isActive, gsbhcf: item.isActive }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["map", { open: item.isOpen }])
                }, [
                  _createElementVNode("img", {
                    src: item.src
                  }, null, 8, _hoisted_11)
                ], 2),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", null, _toDisplayString(item.title), 1),
                    _createElementVNode("h4", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.address), 1),
                  _createElementVNode("a", {
                    target: "_blank",
                    href: item.url
                  }, _toDisplayString(item.urlText), 9, _hoisted_14)
                ])
              ], 2)
            ], 8, _hoisted_10))
          }), 128))
        ], 4)
      ], 8, _hoisted_9)
    ])
  ]))
}
}

})